function t(t,e){let n,l,o=0,u=1e3/e;const a=(e,u=Date.now())=>{o=u,n=null,l&&(clearTimeout(l),l=null),t(...e)};return[(...t)=>{const e=Date.now(),c=e-o;c>=u?a(t,e):(n=t,l||(l=setTimeout(()=>{l=null,a(n)},u-c)))},()=>n&&a(n)]}export{t as default};
//# sourceMappingURL=throttle.js.map
